/**
 * The same leave workflow reads differently for staff (« congé ») and for students and families,
 * who ask for permission to be absent (« demande d'absence »). English keys, translated in "leave".
 */
export type LeaveWording = 'leave' | 'absence'

export const WORDING = {
  leave: {
    request: 'Request leave',
    requested: 'Leave requested',
    balances: 'Balances this academic year',
    balancesLabel: 'Leave balances',
    caption: 'Leave requests',
    cancellable: 'Pending requests, and approved leave that has not started, can be cancelled.',
    empty: 'No leave requested yet',
    confirmCancel: 'Cancel this leave request?',
    loadingTypes: 'Loading leave types…',
    typeLabel: 'Leave type',
    noTypes: 'No leave types available',
    noTypesHint: 'The school has not set up leave types yet.',
  },
  absence: {
    request: 'Request an absence',
    requested: 'Absence requested',
    balances: 'Absences allowed this year',
    balancesLabel: 'Absences allowed',
    caption: 'Absence requests',
    cancellable: 'Pending requests, and approved absences that have not started, can be cancelled.',
    empty: 'No absence requested yet',
    confirmCancel: 'Cancel this absence request?',
    loadingTypes: 'Loading absence types…',
    typeLabel: 'Type of absence',
    noTypes: 'No absence types available',
    noTypesHint: 'The school has not set up absence types yet.',
  },
} as const satisfies Record<LeaveWording, Record<string, string>>
